import Authors from '@/components/Authors';
import CardLink from '@/components/CardLink';
import { formatDate } from '@/utils/date';

export default function NewsroomCard({
  authors,
  externalUrl,
  linkPath,
  id,
  title,
  publishedOn,
  subTitle,
}) {
  const friendlyPublishedOn = formatDate(publishedOn);

  return (
    <CardLink externalUrl={externalUrl} linkPath={linkPath} key={id}>
      <div className="flex flex-col md:flex-row md:items-start md:space-x-2">
        {authors && (
          <div className="-ml-px flex w-full max-w-[75px] items-center justify-start md:mt-1 md:justify-center">
            <Authors people={authors} expand={false} />
          </div>
        )}
        <div className="w-full">
          <h3 className="text-lg text-haiti group-hover:text-rose md:text-xl">
            {title}
          </h3>
          <div className="space-y-1">
            <p className="text-sm text-mid-gray md:text-base">{subTitle}</p>
            <p className="text-xs font-medium text-haiti md:text-sm">
              Published on {friendlyPublishedOn}
            </p>
          </div>
        </div>
      </div>
    </CardLink>
  );
}
